package puzzlekey

import kotlin.math.sqrt

/**
 * Averages the embedding over the last [frames] Scans (ADR-0011 §7): each one L2-normalised first, so a
 * frame counts the same whatever its length. Off by default (one frame, passed through untouched); it is
 * switched on only if T13's hand check on the iPhone is poor, since the corpus has no consecutive frames.
 */
class RecentEmbeddings(val frames: Int = 1) {
    init { require(frames >= 1) { "averaging needs at least one frame, got $frames" } }

    private val window = ArrayDeque<FloatArray>()

    /** The embedding to project for this Scan, given its own [embedding]. */
    fun next(embedding: FloatArray): FloatArray {
        if (frames == 1) return embedding
        var norm = 0.0
        for (v in embedding) norm += v.toDouble() * v
        norm = sqrt(norm)
        window.addLast(FloatArray(embedding.size) { (embedding[it] / norm).toFloat() })
        if (window.size > frames) window.removeFirst()
        return FloatArray(embedding.size) { i -> (window.sumOf { it[i].toDouble() } / window.size).toFloat() }
    }

    /** Forgets the window, e.g. when the camera stops: frames from before don't belong to the next Scan. */
    fun clear() = window.clear()
}
